import React from "react";
import { Maybe } from "../../graphql-types";

type Props = {
  images: {
    description?: Maybe<string>;
    localFile: {
      publicURL?: Maybe<string>;
    };
  }[];
};

export function BenefitImageList({ images }: Props) {
  return (
    <div className="benefits-icons">
      <ul className="flex flex-wrap max-w-3xl p-4 mx-auto my-10">
        {images.map(({ description, localFile }) => (
          <li
            key={description}
            className="p-4 mx-auto text-base font-extrabold leading-tight text-center w-1/2 md:w-1/4 md:p-2"
          >
            <div
              className="inline-block mb-5 bg-center bg-no-repeat bg-contain"
              style={{
                width: "128px",
                height: "128px",
                backgroundImage: `url(${localFile.publicURL}`,
              }}
            ></div>
            <span
              className="block font-semibold break-words text-smaller"
              dangerouslySetInnerHTML={{
                __html: description || "",
              }}
            ></span>
          </li>
        ))}
      </ul>
    </div>
  );
}
